var $4da03c1ecd9a9c7d$exports = {};
$4da03c1ecd9a9c7d$exports = {
    "alpha": `Alfa`,
    "blue": `Modr\xe1`,
    "brightness": `Jas`,
    "green": `Zelen\xe1`,
    "hue": `Odtie\u{148}`,
    "lightness": `Svetlos\u{165}`,
    "red": `\u{10C}erven\xe1`,
    "saturation": `S\xfdtos\u{165}`
};


export {$4da03c1ecd9a9c7d$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
